export const GOOGLE_REVIEW_LINK = "https://g.page/r/CUVEFVbP5JTnEBM/review";
export const APP_STORE_LINK = "https://apps.apple.com/us/app/remi/id6749349121";
export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.remihq.app";
export const BROKEN_IMAGE_SRC = "/images/broken-image.svg";
